const semanticClassNames = {
    inputContainer: 'input-area__input-container',
};
export default semanticClassNames;
//# sourceMappingURL=InputArea.semanticClassNames.js.map